import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=af54349e&"
import script from "./UsersEdit.vue?vue&type=script&lang=js&"
export * from "./UsersEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports